import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type { SummarySettingResponse } from './types';

export const getSummarySettings = (accountId: string) => {
  return doGet<SummarySettingResponse>(
    `accounts/${accountId}/summary-settings`,
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};
